import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ blog }) => {
  // Format date
  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Get default image if no featured image
  const getImageSrc = () => {
    if (blog.featuredImage) {
      return blog.featuredImage;
    }
    // Return a placeholder image
    return `${process.env.PUBLIC_URL}/assets/img/blog-placeholder.jpg`;
  };

  return (
    <div className="card h-100 shadow-sm border-0 blog-card">
      {/* Featured Image */}
      <div className="card-img-top-wrapper" style={{ height: '200px', overflow: 'hidden' }}>
        <img
          src={getImageSrc()}
          className="card-img-top"
          alt={blog.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.3s ease'
          }}
          onError={(e) => {
            e.target.src = `${process.env.PUBLIC_URL}/assets/img/blog-placeholder.jpg`;
          }}
        />
      </div>

      <div className="card-body d-flex flex-column">
        {/* Tags */}
        {blog.tags && blog.tags.length > 0 && (
          <div className="mb-2">
            {blog.tags.slice(0, 3).map((tag, index) => (
              <span
                key={index}
                className="badge bg-primary me-1 mb-1"
                style={{ fontSize: '0.75rem' }}
              >
                {tag}
              </span>
            ))}
          </div>
        )}

        {/* Title */}
        <h5 className="card-title mb-2">
          <Link
            to={`/blog/${blog.slug}`}
            className="text-decoration-none text-dark"
            style={{ 
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
          >
            {blog.title}
          </Link>
        </h5>

        {/* Excerpt */}
        <p 
          className="card-text text-muted flex-grow-1"
          style={{ 
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            fontSize: '0.9rem'
          }}
        >
          {blog.excerpt}
        </p>

        {/* Meta Information */}
        <div className="mt-auto">
          <div className="d-flex justify-content-between align-items-center text-muted small">
            <div className="d-flex align-items-center">
              <i className="bi bi-calendar3 me-1"></i>
              <span>{formatDate(blog.publishedAt || blog.createdAt)}</span>
            </div>
            
            <div className="d-flex align-items-center">
              <i className="bi bi-clock me-1"></i>
              <span>{blog.readTime || 5} min read</span>
            </div>
          </div>

          {/* Author */}
          {blog.author && (
            <div className="d-flex align-items-center mt-2 text-muted small">
              <i className="bi bi-person me-1"></i>
              <span>By {blog.author}</span>
            </div>
          )}

          {/* Read More Button */}
          <div className="mt-3">
            <Link
              to={`/blog/${blog.slug}`}
              className="btn btn-outline-primary btn-sm"
            >
              Read More <i className="bi bi-arrow-right ms-1"></i>
            </Link>
          </div>
        </div>
      </div>


    </div>
  );
};

export default BlogCard;